
import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { getCommunity } from "../../services/apiProfile";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import "../../assets/css/joincommunityyy.css";
import greensave from "../../assets/img/greensave.svg";
import { createCommunity } from "../../services/apiCommunity";
import videoimg from "../../assets/img/video-img.svg"
import playimg from "../../assets/img/play-circles.svg"
import bookmark from "../../assets/img/bookmark.svg"
import "../../assets/css/save.css";
import "../../assets/css/dreampost.css";
import search from "../../assets/img/sreach---icon.svg"
import PodCast from "../Profile/PodCastPopup";
import { getPodcasts, savePodcast } from "../../services/apiOtherlink";


const DreamersPodcast = () => {
    const [userId, setUserId] = useState('');
    const [podcastArr, setPodCastArr] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [isCurrentYouTube, setIsCurrentYouTube] = useState(false);
    const user = JSON.parse(localStorage.getItem('userData'));
    const [isPodCastPlay, setIsPodCastPlay] = useState(false);
    const [savedPodcasts, setSavedPodcasts] = useState(new Set());
    const MEDIA_BASE_URL = process.env.REACT_APP_IMAGE_URL;
  const DEFAULT_NO_IMAGE_PLACEHOLDER = process.env.REACT_DEFAULT_NO_IMAGE_URL;


    useEffect(() => {
        fetchpodCast(searchKey);
    }, [])
    useEffect(() => {
        fetchpodCast(searchKey)
    }, [searchKey])

    const isVideoFile = (url) => {
        if (!url) return false;
        const videoExtensions = /\.(mp4|webm|ogg|avi|mov|flv|wmv|mkv)$/i;
        return videoExtensions.test(url.toLowerCase());
    };

    const isImageFile = (url) => {
        if (!url) return false;
        const imageExtensions = /\.(jpeg|jpg|gif|png|bmp|webp|svg)$/i;
        return imageExtensions.test(url.toLowerCase());
    };

    const generateVideoThumbnail = useCallback((videoUrl) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            video.src = videoUrl;
            video.crossOrigin = 'anonymous';
            video.preload = 'metadata';
            video.muted = true;
            video.style.display = 'none'; // Hide video element
            video.currentTime = 0.5; // Try to get a frame from 0.5 seconds into the video

            let timeoutId = null;

            const cleanup = () => {
                if (timeoutId) clearTimeout(timeoutId);
                video.removeEventListener('loadedmetadata', onLoadedMetadata);
                video.removeEventListener('seeked', onSeeked);
                video.removeEventListener('error', onError);
                video.removeEventListener('canplaythrough', onCanPlayThrough);
                if (video.parentNode) {
                    video.parentNode.removeChild(video);
                }
            };

            const onLoadedMetadata = () => {
                video.currentTime = Math.min(1, video.duration / 2 || 0);
            };

            const onSeeked = () => {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const ctx = canvas.getContext('2d');
                try {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    resolve(canvas.toDataURL('image/jpeg'));
                } catch (e) {
                    console.error("Error drawing video to canvas (CORS/tainted canvas likely):", videoUrl, e);
                    resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+CORS+Error');
                } finally {
                    cleanup();
                    canvas.remove();
                }
            };

            const onError = (e) => {
                console.error("Error loading video for thumbnail:", videoUrl, e);
                resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+Load+Error');
                cleanup();
            };

            const onCanPlayThrough = () => {
                if (timeoutId) clearTimeout(timeoutId);
            };

            video.addEventListener('loadedmetadata', onLoadedMetadata);
            video.addEventListener('seeked', onSeeked);
            video.addEventListener('error', onError);
            video.addEventListener('canplaythrough', onCanPlayThrough);

            document.body.appendChild(video);

            timeoutId = setTimeout(() => {
                console.warn("Video thumbnail generation timeout for:", videoUrl);
                resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+Timeout');
                cleanup();
            }, 7000);
        });
    }, [DEFAULT_NO_IMAGE_PLACEHOLDER]);



    const getYouTubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

const fetchpodCast = async (key) => {
  const formData = {
    userid: user._id,
    searchkey: key,
    offset: 0,
    limit: 20
  };

  let podcast = await getPodcasts(formData);

  if (podcast.podcast) {
    const processedItemsPromises = podcast.podcast.map(async (item) => {
      let thumbnailUrl = DEFAULT_NO_IMAGE_PLACEHOLDER;
      let videoUrl = null;
const mediaType = item.mediaType?.toLowerCase();
      if (mediaType === "youtube" && item.youtubeurl) {
        const videoId = getYouTubeVideoId(item.youtubeurl);
        if (videoId) {
          thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          videoUrl = `https://www.youtube.com/embed/${videoId}`;
        }
      } else if (mediaType === "video" && item.videourl) {
        const fullMediaUrl = `${MEDIA_BASE_URL}${item.videourl}`;
        videoUrl = fullMediaUrl;
        thumbnailUrl = await generateVideoThumbnail(fullMediaUrl);
      } else if (isImageFile(item.videourl)) {
        thumbnailUrl = `${MEDIA_BASE_URL}${item.videourl}`;
      }

      return {
        id: item._id,
        videoUrl,
        imageUrl: thumbnailUrl,
        isYouTube: item.mediaType === "youtube",
        title: item.title,
        description: item.description || 'No description available.',
        savedpodcast: item.savedpodcast || []
      };
    });

    const fetchedItems = await Promise.all(processedItemsPromises);
    setPodCastArr(fetchedItems);
  }
};

    const handleSavePodCast = async (podId, isCurrentlySaved) => {
        const formData = {
            userid: user._id,
            podcastid: podId,
        }
        
        if (!isCurrentlySaved) {
            let savepodcast = await savePodcast(formData);
            
            if (savepodcast.status === true) {
                setSavedPodcasts(prev => new Set(prev).add(podId));
                fetchpodCast(searchKey)
            }
        }
        

    }
    
const handlePlay = (url, isYouTube) => {
  setCurrentVideoUrl(url);
  setIsCurrentYouTube(isYouTube);
  setIsPodCastPlay(true);
};
    const handleClose = () => {
        setIsPodCastPlay(false);
    };
    return (
        <div>
            <div class="">
                <div class="row">
                    <div className="hd-breadcums">
                        <h3 className="main-heading">Dreamers Health Media</h3>
                    </div>
                    <div class="col-lg-4 my-2 ">
                        <div class="d-flex ">
                            <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                                <span className="mobil-view-class border-end-0 ">
                                    <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                                </span>
                                <input type="text" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                                    onChange={(e) => { setSearchKey(e.target.value) }} value={searchKey} />
                            </div>

                        </div>
                    </div>
                    <div class="container my-3">
                        <div class="row ">
                            {podcastArr.map((podcasts, index) => {
                                
                                
                                return(
                                    <div class="col-12 col-sm-10 col-md-6 col-lg-3 mb-4">
                                    <div class="podcast-card ">
                                        <div class="podcast-img position-relative">
                                            <img
                                                src={podcasts.imageUrl}
                                                alt="Podcast thumbnail"
                                                className="img-fluid video-img"
                                            />
                                            <button type="button"
                                                className="play-bttn position-absolute top-50 start-50 translate-middle"
                                                onClick={() => { handlePlay(podcasts.videoUrl, podcasts.isYouTube) }}>
                                                <img src={playimg} alt="Play icon" className="play-img-overlay" />
                                            </button>
                                            <div class="overlay-podcat"></div>
                                           
                                        </div>
                                        <div class="podcast-body">
                                           
                                            <div class="d-flex justify-content-between align-items-center card-footer">
                                                <div class="podcast-description">
                                                    {podcasts.title}
                                                </div>
                                                <div className="savepost">
                                                    <div className="post-saved">
                                                        
                                                        <button className="btn save-img-bttn" onClick={() => { handleSavePodCast(podcasts.id, podcasts.savedpodcast[0]?.issaved) }}>
                                                            <img src={podcasts.savedpodcast[0]?.issaved ? greensave : bookmark} alt="Play icon" className="save-img-post" />
                                                        </button>
                                                        <span className="savetext"><Link onClick={() => { handleSavePodCast(podcasts.id, podcasts.savedpodcast[0]?.issaved) }}>{podcasts.savedpodcast[0]?.issaved ? "Saved" : "Save"}</Link></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                            })}
                        </div>
                    </div>

                </div>
            </div>
            {isPodCastPlay ? <PodCast isPodCastPlay={isPodCastPlay} handleClose={handleClose} podUrl={currentVideoUrl} isCurrentYouTube={isCurrentYouTube} /> : null}
        </div>
    );
};

export default DreamersPodcast;
